import React , { useState, useRef, useEffect }from "react";
import "../assets/style/components/Navbar.scss";
import { NavLink, Link   } from "react-router-dom";

const Navbar = () => {
    const [activeId, setActiveId] = useState(1);
    const [hoverId, setHoverId] = useState(null);
    const [sliderStyle, setSliderStyle] = useState({});
    const containerRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [cross, setCross] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    
    const navItems = [
        { id: 1, to: "/", label: "Accueil" },
        { id: 2, to: "/infrastructures", label: "Infrastructures" },
        { id: 3, to: "/pensions", label: "Pensions" },
        { id: 4, to: "/actualites", label: "Actualités" },
        { id: 5, to: "/contact", label: "Contact", extraClass: "d-md-none d-block" }
    ];

    useEffect(() => {
        let timer;
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
            timer = setTimeout(() => setCross(true), 250);
        } else {
            document.body.style.overflow = 'scroll';
            timer = setTimeout(() => setCross(false), 250);
        }
        return () => clearTimeout(timer);
    }, [menuOpen]);

     useEffect(() => {
        const idToUse = hoverId || activeId;
        const activeItem = containerRef.current.querySelector(`.nav-item[data-id="${idToUse}"]`);
        if (activeItem) {
        const { offsetLeft, offsetWidth } = activeItem;
        setSliderStyle({ left: offsetLeft, width: offsetWidth });
        }
    }, [activeId, hoverId]);


    return (
        <nav>
            <div
                className={`burger-menu ${menuOpen ? " open" : ""}${cross ? " cross" : ""}`}
                onClick={() => setMenuOpen(open => !open)}
                type="button"
            >
                <span className="burger-line top"></span>
                <span className="burger-line middle"></span>
                <span className="burger-line bottom"></span>
            </div>
            <div className={`nav-container ${menuOpen ? "open" : ""}`}>
                <img src="pictures/logo-minimized.svg" className="nav-logo" alt="logo"/>
                <div className="link-container" ref={containerRef}>
                <div className="slider" style={sliderStyle}></div>
                   {navItems.map((item) => {
                        const isHighlighted = hoverId === item.id || (activeId === item.id && hoverId == null);
                        return(
                            <NavLink
                                key={item.id}
                                to={item.to}
                                data-id={item.id}
                                className={({ isActive }) =>
                                    `nav-item ${isHighlighted  ? "highlighted" : ""} ${item.extraClass || ""}`
                                }
                                onClick={() => {
                                    setMenuOpen(false);
                                    setActiveId(item.id);
                                }}
                                onMouseEnter={() => setHoverId(item.id)}
                                onMouseLeave={() => setHoverId(null)}
                                >
                                <h5 className="nav-link">{item.label}</h5>
                            </NavLink>
                        )}
                    )}
                </div>
                <button className="nav-button">
                    <Link to="/contact" 
                        onClick={() => {
                            setMenuOpen(false);
                            setActiveId(5);
                        }}>
                            Contact
                    </Link >
                </button>
            </div>
        </nav>
    );
}

export default Navbar;